import Cookie from './cookie';

let debug = Cookie.get('shop_ordercall_debug') || '0';

const shopOrdercall = {
    debug: !!(+debug),
    uiVersion: (<any>window).ordercall_ui_version,
    pluginVersion: (<any>window).ordercall_plugin_version,
    pluginUrl: (<any>window).ordercall_plugin_url,
    setDebug(debug?: boolean) {
        this.debug = debug || false;
        Cookie.set('shop_ordercall_debug', (+this.debug).toString());
    }
};

if ((<any>window).shopOrdercall == undefined) {
    (<any>window).shopOrdercall = shopOrdercall;
}

export default shopOrdercall;



// WEBPACK FOOTER //
// ./src/webpack/vue/shop.ordecall.ts